export default __webpack_public_path__ + "static/media/fauna-abac-th.43d9d776.jpg";